import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth, formatApiError } from "@/lib/api";
import { Lock, Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_8465ce77-9585-4fff-bcf3-0cae1d417cf9/artifacts/w0kkj7ub_WhatsApp_Image_2026-02-27_at_19.16.07-removebg-preview%20%282%29.png";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (auth.isLogged()) navigate("/admin", { replace: true });
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await auth.login(email.trim().toLowerCase(), password);
      toast.success("Accesso effettuato");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main
      data-testid="admin-login-page"
      className="min-h-screen bg-[#f8fafc] flex items-center justify-center p-6 relative overflow-hidden"
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle at 50% 30%, rgba(118,186,27,0.12), transparent 55%)",
        }}
      />

      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="relative w-full max-w-md bg-white rounded-3xl p-8 border border-slate-200 shadow-[0_30px_80px_rgba(15,23,42,0.08)]"
      >
        <div className="flex flex-col items-center mb-8">
          <img
            src={LOGO_URL}
            alt="Minicarmobilità"
            className="h-16 w-16 rounded-2xl bg-white ring-2 ring-[#76BA1B]/40 mb-4"
          />
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#76BA1B] font-bold mb-2">
            Pannello Admin
          </div>
          <h1 className="font-heading text-2xl font-bold text-[#1e293b]">Accedi al gestionale</h1>
        </div>

        <label className="block mb-4">
          <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-1.5 font-bold">Email</div>
          <div className="relative">
            <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              type="email" required autoFocus
              data-testid="admin-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full pl-10 pr-4 py-3 rounded-xl bg-white border border-slate-200 text-sm text-[#1e293b] placeholder-slate-400 focus:border-[#76BA1B] focus:shadow-[0_0_0_4px_rgba(118,186,27,0.12)] outline-none transition"
              placeholder="admin@…"
            />
          </div>
        </label>

        <label className="block mb-6">
          <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-1.5 font-bold">Password</div>
          <div className="relative">
            <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              type="password" required
              data-testid="admin-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full pl-10 pr-4 py-3 rounded-xl bg-white border border-slate-200 text-sm text-[#1e293b] placeholder-slate-400 focus:border-[#76BA1B] focus:shadow-[0_0_0_4px_rgba(118,186,27,0.12)] outline-none transition"
              placeholder="••••••••"
            />
          </div>
        </label>

        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="w-full px-6 py-3.5 rounded-xl bg-[#76BA1B] text-white font-bold hover:bg-[#5fa015] hover:shadow-[0_10px_30px_rgba(118,186,27,0.5)] disabled:opacity-60 transition-all flex items-center justify-center gap-2"
        >
          {loading ? <Loader2 size={16} className="animate-spin" /> : null}
          {loading ? "Accesso in corso…" : "Entra"}
        </button>

        <a href="/" className="block text-center mt-5 text-xs text-slate-500 hover:text-[#76BA1B] transition">
          ← Torna al sito
        </a>
      </form>
    </main>
  );
}
